import Axios from 'axios'
import store from '@/store'
import router from '@/router'
import Vue from 'vue'

export const axiosInstance = createAxios()

export default function setup () {
  Vue.prototype.$axios = axiosInstance
}

export function createAxios (baseURL = process.env.VUE_APP_BACKEND_BASE_URL) {
  const axios = Axios.create({ baseURL })
  axios.interceptors.request.use(
    function (config) {
      const token = store.getters['auth/token']
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    function (error) {
      if (error?.response?.status === 401) {
        store.dispatch('auth/logout')
        router.push('/login')
      }
      return Promise.reject(error)
    }
  )
  axios.interceptors.response.use(
    (r) => Promise.resolve(r),
    (responseError) => {
      // console.error(responseError.response, responseError.request)
      if (responseError?.response?.status === 401) {
        store.dispatch('auth/logout')
        router.push('/login')
      }
      if (responseError?.response?.status === 403) {
        // store.dispatch('auth/logout')
        // router.push('/snapshots')
      }
      return Promise.reject(responseError)
    }
  )
  return axios
}
